import { render, staticRenderFns } from "./VirtualListUser.vue?vue&type=template&id=54afe52e"
import script from "./VirtualListUser.vue?vue&type=script&lang=js"
export * from "./VirtualListUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports